'use strict';

angular.module('DownloadClient')

  .controller('DownloadClientController', function (
    $scope, deviceDetector, TenantListService, ApplicationType, CpuArchitecture, FileType, OperatingSystem, SoftwareService) {

    (function () {
      $scope.isPrintixEnabled = TenantListService.currentTenant.isPrintixEnabled();
      const detectedOs = deviceDetector.os.substring(0, 3).toUpperCase();
      $scope.isWindowsOs = detectedOs === OperatingSystem.WIN;
      $scope.isMacOs = detectedOs === OperatingSystem.MAC;
      if ($scope.isPrintixEnabled && ($scope.isWindowsOs || $scope.isMacOs)) {
        getConfiguredSoftwareVersion();
      }
    })();

    function getConfiguredSoftwareVersion() {
      if ($scope.isWindowsOs) {
        getConfiguredSoftwareVersionForWindowsX64();
        getConfiguredSoftwareVersionForWindowsArm64();
      } else if ($scope.isMacOs) {
        getConfiguredSoftwareVersionForMac();
      }
    }

    function getConfiguredSoftwareVersionForWindowsX64() {
      SoftwareService.getConfiguredSoftwareVersion(ApplicationType.CLIENT, OperatingSystem.WIN, CpuArchitecture.X64, FileType.EXE)
        .then(function (responseData) {
          const softwareVersion = responseData._embedded['px:softwareResources'][0];
          if (softwareVersion.files.length) {
            $scope.windowsX64DownloadUrl = SoftwareService.buildDesktopApplicationDownloadUrl(
              ApplicationType.CLIENT, OperatingSystem.WIN, CpuArchitecture.X64, FileType.EXE, softwareVersion.version);
          } else {
            $scope.windowsX64DownloadUrl = null;
          }
        })
        .catch(function () {
          $scope.windowsX64DownloadUrl = null;
        });
    }

    function getConfiguredSoftwareVersionForWindowsArm64() {
      SoftwareService.getConfiguredSoftwareVersion(ApplicationType.CLIENT, OperatingSystem.WIN, CpuArchitecture.ARM64, FileType.EXE)
        .then(function (responseData) {
          const softwareVersion = responseData._embedded['px:softwareResources'][0];
          if (softwareVersion.files.length) {
            $scope.windowsArm64DownloadUrl = SoftwareService.buildDesktopApplicationDownloadUrl(
              ApplicationType.CLIENT, OperatingSystem.WIN, CpuArchitecture.ARM64, FileType.EXE, softwareVersion.version);
          } else {
            $scope.windowsArm64DownloadUrl = null;
          }
        })
        .catch(function () {
          $scope.windowsArm64DownloadUrl = null;
        });
    }

    function getConfiguredSoftwareVersionForMac() {
      SoftwareService.getConfiguredSoftwareVersion(ApplicationType.CLIENT, OperatingSystem.MAC, undefined, FileType.DMG)
        .then(function (responseData) {
          const softwareVersion = responseData._embedded['px:softwareResources'][0];
          if (softwareVersion.files.length) {
            $scope.macDownloadUrl = SoftwareService.buildDesktopApplicationDownloadUrl(
              ApplicationType.CLIENT, OperatingSystem.MAC, undefined, FileType.DMG, softwareVersion.version);
          } else {
            $scope.macDownloadUrl = null;
          }
        })
        .catch(function () {
          $scope.macDownloadUrl = null;
        });
    }

  });
